export type EnumType<T> = {
  [id: string]: string | T
}

export type EnumKey<T extends { [key: string]: any }> = keyof T

export function getEnumValues<T>(anEnum: EnumType<T>): T[] {
  const values: T[] = []
  Object.values(anEnum).forEach(v => {
    if (typeof v === 'string') {
      const reverse = anEnum[v]
      values.push((reverse === undefined ? v : reverse) as T)
    }
  })
  return values
}

export function getEnumValue<T>(anEnum: EnumType<T>, key: unknown): T {
  return Object.entries(anEnum)
    .find(([k, _]) => k === key)
    ?.at(1) as T
}

export function getEnumKeys<T extends {}>(enumType: T): (keyof T)[] {
  return (Object.keys(enumType) as Array<keyof T>).filter(
    value => isNaN(Number(value)) !== false,
  )
}

export function getEnumKey<T extends {}>(
  enumType: T,
  value: T[keyof T],
): keyof T {
  return Object.entries(enumType)
    .find(([_, v]) => v === value)
    ?.at(0) as keyof T
}

export function isEnumValue<T extends {}>(
  enumType: T,
  value: unknown,
): value is T[keyof T] {
  return Object.values(enumType).includes(value)
}
